import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPlayerLoginInfoTimeout = () => {
    const send = useGenericSend();

    return useCallback(() => send<Types.IGetPlayerLoginInfoRequest, Types.IGetPlayerLoginInfoResponse>({
        ID: 81111,
        description: 'Get Player Login Info Request (inactivity timeout)',
        requestedPlayerData: [5],
        responses: [81113, 81100]
    }), [send]);
};
